import {
    checkAndGetLocalStorageValue,
    checkAndGetSessionStorageValue,
    generateJsonWebToken,
} from "../../../../features/utils";
import { commonConstant } from "../../../../server/triage/constants";

export async function getServiceIdList({state, actions, store }) {
  var organizationId = checkAndGetLocalStorageValue("orgid");
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  const data = {
    orgId: organizationId,
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
  };

  var response = await actions.sendTriageRequest({
    action: "getExcludedServiceIds",
    data
    });

    if (response && response.message === commonConstant.success) {
      if(response.excludedServiceAccessPointId){
      actions.setTriageRequest({
        excludedServiceAccessPointId:
          response.excludedServiceAccessPointId,
      });
    }
     return await actions.accessListDetails();
    }
}
